import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function MoreThan200Section() {
  const benefits = ['Risparmiano tempo ogni settimana', 'Riducono le merendine industriali', 'Hanno sempre idee pronte', 'Organizzano meglio la spesa', 'Preparano pasti più equilibrati', 'Vivono i pasti con meno stress'];
  return <section className="bg-white py-20 px-4" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <div className="text-center mb-16" data-id="element-101">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] mb-10" data-id="element-102">
            PERCHÉ LE MAMME AMANO{' '}
            <span className="text-green-600" data-id="element-103">MERENDE FELICI?</span>
          </motion.h2>

          <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto text-left mb-20" data-id="element-104">
            {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-center gap-3 bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-105">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={24} data-id="element-106" />
                <span className="font-semibold text-gray-800" data-id="element-107">{benefit}</span>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1f2e10] text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-108">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#c4f000]" data-id="element-109"></div>

          <h3 className="text-2xl md:text-4xl font-black mb-8 text-[#c4f000]" data-id="element-110">
            IMMAGINA TRA 30 GIORNI...
          </h3>

          <div className="space-y-4 text-lg md:text-xl text-gray-200 font-medium mb-10" data-id="element-111">
            <p data-id="element-112">Aprire il frigorifero e sapere già cosa preparare.</p>
            <p data-id="element-113">Non dover cercare ricette ogni sera.</p>
            <p data-id="element-114">Avere snack sani sempre pronti.</p>
            <p data-id="element-115">Vedere tuo figlio mangiare meglio.</p>
            <p className="text-white font-bold text-2xl mt-6" data-id="element-116">
              E sentirti finalmente organizzata.
            </p>
          </div>

          <p className="text-gray-400 italic" data-id="element-117">
            Questa è la trasformazione che Merende Felici vuole offrirti.
          </p>
        </motion.div>
      </div>
    </section>;
}